import { render, staticRenderFns } from "./SkupTemaCreate.vue?vue&type=template&id=0d75338c&scoped=true&"
import script from "./SkupTemaCreate.vue?vue&type=script&lang=js&"
export * from "./SkupTemaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75338c",
  null
  
)

export default component.exports